import { useTranslation } from '@/i18n';
import { IconInfo, Loading } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo, Suspense } from 'react';
import { AddViewerForm } from '../components/AddViewerForm';
import { ViewerList } from '../components/ViewerList';
import { useShareViewers } from '../hooks/useShareViewers';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

type ContentsProps = {
  reportId: string;
  refetch: () => void | Promise<unknown>;
  onCloseDetailDrawer: () => void;
};

const InnerContents: FC<ContentsProps> = ({
  reportId,
  refetch,
  onCloseDetailDrawer,
}) => {
  const { t } = useTranslation();
  const { data } = useShareViewers({ reportId, refetch, onCloseDetailDrawer });
  const viewers = data?.viewers ?? [];

  return (
    <div className={cx('container')}>
      <div className={cx('description')}>
        <IconInfo size={14} />
        <span>{t('invoice_report_share.description')}</span>
      </div>
      <AddViewerForm
        reportId={reportId}
        viewers={viewers}
        maxViewersCount={data?.max_viewers_count}
      />
      <ViewerList reportId={reportId} viewers={viewers} />
    </div>
  );
};
InnerContents.displayName = 'InnerContents';

const FallBackLoading = () => (
  <div className={cx('loading-container')}>
    <Loading size='large' color='default' />
  </div>
);

export const Contents: FC<ContentsProps> = memo((props) => (
  <Suspense fallback={<FallBackLoading />}>
    <InnerContents {...props} />
  </Suspense>
));
Contents.displayName = 'Contents';
